module.exports = __webpack_public_path__ + "img/agency-slide-01.f26ca546.jpg";